
type ProfileLike = { resourceType: string; id?: string } | undefined;

/** Live thread search/recipient is only defined for human participants (not OAuth ClientApplication, Bot, etc.). */
export function isMessagingParticipantProfile(profile: ProfileLike): boolean {
  return profile?.resourceType === 'Patient' || profile?.resourceType === 'Practitioner';
}
